export default __webpack_public_path__ + "static/media/cross-mobile.bed70b74.svg";